import { ActivatedRouteSnapshot, RedirectCommand, Router, RouterStateSnapshot } from "@angular/router";
import { map, switchMap } from "rxjs";
import { getStrategies, StrategyGroupEx } from "@front/m19-models";
import { inject } from "@angular/core";
import { AccountSelectionService, SpStrategyService } from "@front/m19-services";
import { StrategyPageResolver } from "@m19-board/strategies/strategy-page/strategy-page.resolver";

export const substrategyPageResolver: StrategyPageResolver = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const accountSelectionService = inject(AccountSelectionService);
  const spStrategyService = inject(SpStrategyService);

  const params = route.paramMap;

  const groupId = Number(params.get("groupId"));
  const id = Number(params.get("id"));

  return accountSelectionService.singleAccountMarketplaceSelection$.pipe(
    switchMap((am) => spStrategyService.getStrategyGroups(am.accountId, am.marketplace)),
    map((strategyGroups) => strategyGroups.get(groupId)),
    map((strategyGroup: StrategyGroupEx | undefined) => {
      if (!strategyGroup) {
        return new RedirectCommand(router.createUrlTree(["/advertising/sponsored-product"]));
      }

      const strategies = getStrategies(strategyGroup);
      // do not display substrategy page when strategy group has more than one strategy
      if (strategies.length != 1) {
        return new RedirectCommand(router.createUrlTree(["/advertising/sponsored-product/strategy-group/" + groupId]));
      }

      const strategy = strategies.find((s) => s.strategyId == id);
      if (!strategy) {
        return new RedirectCommand(router.createUrlTree(["/advertising/sponsored-product"]));
      }

      return {
        strategyId: strategy.strategyId,
        strategyGroupId: strategyGroup.strategyGroupId,
      };
    }),
  );
};
